// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { updateBackOrder, UpdateBackOrderApiParameter } from "@store/Framework/Services/BackOrderService";

export type UpdateBackOrderParameter = UpdateBackOrderApiParameter & HasOnSuccess & HasOnError<string>;

type HandlerType = ApiHandlerDiscreteParameter<UpdateBackOrderParameter, UpdateBackOrderApiParameter>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        id: props.parameter.id,
        isCancelled: props.parameter.isCancelled,
        newQuantity: props.parameter.newQuantity,
    };
};

export const SendDataToApi: HandlerType = async props => {
    try {
        await updateBackOrder(props.apiParameter);
    } catch (error) {
        if (isApiError(error)) {
            props.parameter.onError?.(error.errorJson?.message || error.errorMessage);
            return false;
        }

        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const updateBackOrderLine = createHandlerChainRunner(chain, "UpdateBackOrder");
export default updateBackOrderLine;
